import { render, staticRenderFns } from "./AvatarSelection.vue?vue&type=template&id=41502cf0&"
import script from "./AvatarSelection.vue?vue&type=script&lang=js&"
export * from "./AvatarSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports